import React from "react";
import BaseModal from "../../../components/ui/BaseModal";
import BaseButton from "../../../components/ui/BaseButton";
import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useUpdateWorkOrder } from "../../../hooks/useUpdateWorkOrder";
import { getCurrentTimeZone, handleGetLocation } from "../../../utils/helpers";
import { checkOut } from "../../../services/api/timeLog";
import dayjs from "dayjs";
import { getTimeZoneAbbreviation } from "../../../utils/getTimeZoneAbbreviation";

const CheckOutModal = ({
  checkOutModalOpen,
  setCheckOutModalOpen,
  tasks,
  refetchUserAllowedAction,
}) => {
  const params = useParams();
  const { updateWorkOrder } = useUpdateWorkOrder();
  const {
    isPending: isCheckOutLoading,
    error: isCheckOutError,
    data: checkOutTimeLogData,
    mutateAsync: checkOutMutation,
  } = useMutation({
    mutationFn: checkOut,
    enabled: false,
  });

  const handleCheckOut = async () => {
    try {
      // Get the user's location
      const location = await handleGetLocation();
      const timezone = getCurrentTimeZone();
      const task = tasks?.find((task) => task.taskType === "CHECK_OUT");
      // Create the payload with correct latitude and longitude
      let payload = {
        checkOutLatitude: parseFloat(location?.latitude),
        checkOutLongitude: parseFloat(location?.longitude), // Corrected key
        workOrderId: parseInt(params.id),
        taskId: task.completedTask.id,
        checkOutTimeZone: timezone,
      };

      const response = await checkOutMutation(payload);
      refetchUserAllowedAction();
      updateWorkOrder();
      setCheckOutModalOpen(false);
    } catch (error) {
      console.error("Error during check-in:", error);
      // Handle the error if necessary
    }
  };
  return (
    <div>
      <BaseModal
        open={checkOutModalOpen}
        close={() => {}}
        style={{ width: "600px" }}
      >
        <div className="container">
          <h6 className="text-dark border-bottom mb-4 pb-1">
            Confirm Check Out
          </h6>
          <p className="bg-primary text-white rounded py-2 px-3">
            You are checking out. Working hours will be calculated accordingly.
          </p>

          <div className="flex items-center justify-between mt-4">
            <p className="font-normal">Check Out Time</p>
            <p>
              {dayjs().format("dddd, MM/D/YYYY")} at {dayjs().format("h:mm A")}{" "}
              (
              {getTimeZoneAbbreviation(
                Intl.DateTimeFormat().resolvedOptions().timeZone,
              )}
              )
            </p>
          </div>
        </div>
        <div
          className="flex items-center justify-center bg-white py-6 px-5 mt-3"
          style={{
            boxShadow: "5px 0px 14px 5px rgba(0, 0, 0, 0.07)",
          }}
        >
          <BaseButton
            className="py-[5px] px-2 bg-[#E8E8E8] text-dark"
            fullWidth={false}
            onClick={() => setCheckOutModalOpen(false)}
          >
            <p>Cancel</p>
          </BaseButton>
          <BaseButton
            disabled={isCheckOutLoading}
            isLoading={isCheckOutLoading}
            className="py-[5px] px-4 ml-4"
            color="primary"
            fullWidth={false}
            onClick={handleCheckOut}
          >
            Confirm Check Out
          </BaseButton>
        </div>
      </BaseModal>
    </div>
  );
};

export default CheckOutModal;
